import './styles.scoped.css';
export default {
  "root": "awsui_root_1fcus_1tvae_93",
  "clickable": "awsui_clickable_1fcus_1tvae_102",
  "precise": "awsui_precise_1fcus_1tvae_106",
  "focus-outline": "awsui_focus-outline_1fcus_1tvae_110",
  "application": "awsui_application_1fcus_1tvae_119"
};